import _get from 'lodash/get';
import { fetcher } from '../../utility/domUtils';
import { getUserType } from '../utilsV3/authUtils';

export const SET_COUNT_DONATIONS = 'SET_COUNT_DONATIONS';
export const SET_LAST_UPDATED_DONATION_PAGE = 'SET_LAST_UPDATED_DONATION_PAGE';
export const POST_ORGANIZER_UPDATE_ERROR = 'POST_ORGANIZER_UPDATE_ERROR';
export const POST_ORGANIZER_UPDATE_SUCCESS = 'POST_ORGANIZER_UPDATE_SUCCESS';
export const EDIT_ORGANIZER_UPDATE_ERROR = 'EDIT_ORGANIZER_UPDATE_ERROR';
export const EDIT_ORGANIZER_UPDATE_SUCCESS = 'EDIT_ORGANIZER_UPDATE_SUCCESS';
export const GET_ORGANIZER_UPDATES = 'GET_ORGANIZER_UPDATES';
export const GET_ORGANIZER_UPDATES_ERROR = 'GET_ORGANIZER_UPDATES_ERROR';
export const GET_ORGANIZER_UPDATES_SUCCESS = 'GET_ORGANIZER_UPDATES_SUCCESS';
export const DELETE_ORGANIZER_UPDATE_SUCCESS =
  'DELETE_ORGANIZER_UPDATE_SUCCESS';
export const DELETE_ORGANIZER_UPDATE_ERROR = 'DELETE_ORGANIZER_UPDATE_ERROR';
export const UPDATE_TEXT_ORGANIZER = 'UPDATE_TEXT_ORGANIZER';
export const UPDATE_SUBJECT_ORGANIZER = 'UPDATE_SUBJECT_ORGANIZER';
export const INCREMENT_ORGANIZER_UPDATE_COUNT =
  'INCREMENT_ORGANIZER_UPDATE_COUNT';
export const DECREMENT_ORGANIZER_UPDATE_COUNT =
  'DECREMENT_ORGANIZER_UPDATE_COUNT';

export function setLastUpdated(donationPage) {
  return {
    type: SET_LAST_UPDATED_DONATION_PAGE,
    payload: donationPage,
  };
}
export function getDonationPagesList() {
  return (dispatch) => {
    let resParams = {};
    if (getUserType() === 'PERSONAL') {
      // Return empty donation page list to Personal user type
      dispatch({
        type: SET_COUNT_DONATIONS,
        donationPagesCount: 0,
      });
      return Promise.resolve({ ok: 'OK', donationPages: [] });
    }
    return fetcher('/donate/api/getDonationPages', {
      method: 'GET',
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          return {
            ...responseJson?.error,
            ...resParams,
          };
        }
        const donationPages = _get(responseJson, 'donationPages');
        dispatch({
          type: SET_COUNT_DONATIONS,
          donationPagesCount: donationPages?.length,
        });
        return { ok: resParams.ok, donationPages: donationPages };
      })
      .catch((error) => {
        return error;
      });
  };
}

export function uploadImage(imageUrl) {
  return () => {
    let resParams = {};
    return fetcher('/donate/api/imageUpload', {
      method: 'POST',
      body: JSON.stringify({
        src: imageUrl,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          return {
            ...responseJson?.error,
            ...resParams,
          };
        }
        const url = _get(responseJson, 'url');
        return { src: url.imageUrl, ok: resParams.ok, success: url.success };
      })
      .catch((error) => {
        return error;
      });
  };
}

export function updateBusinessProfileLogo(imageUrl) {
  return () => {
    let resParams = {};
    return fetcher('/donate/api/updateBusinessProfile', {
      method: 'PUT',
      body: JSON.stringify({
        url: imageUrl,
      }),
    })
      .then((response) => {
        resParams = {
          resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          return {
            success: responseJson.success,
            ...resParams,
          };
        }
        return { ok: resParams.ok, success: responseJson.success };
      })
      .catch((error) => {
        return error;
      });
  };
}

export function getOrganizerUpdates(campaignId, page) {
  return (dispatch) => {
    let resParams = {};
    dispatch({
      type: GET_ORGANIZER_UPDATES,
    });
    return fetcher(
      `/donate/api/setup/campaigns/${campaignId}/updates?page=${page}`,
      {
        method: 'GET',
      }
    )
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            ...responseJson?.error,
            ...resParams,
          };
          dispatch({
            type: GET_ORGANIZER_UPDATES_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const organizerUpdates = _get(
          responseJson,
          'data.organizerUpdates.items',
          []
        );
        const total = _get(responseJson, 'data.organizerUpdates.total', []);
        dispatch({
          type: GET_ORGANIZER_UPDATES_SUCCESS,
          payload: {
            organizerUpdates,
            total,
          },
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: GET_ORGANIZER_UPDATES_ERROR,
          payload: { error },
        });
        return error;
      });
  };
}

export function postOrganizerUpdates(campaignId, update) {
  return (dispatch) => {
    let resParams = {};
    return fetcher(`/donate/api/campaigns/${campaignId}/updates`, {
      method: 'POST',
      body: JSON.stringify(update),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            ...responseJson?.error,
            ...resParams,
          };
          dispatch({
            type: POST_ORGANIZER_UPDATE_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }

        const organizerUpdate = _get(responseJson, 'data.organizerUpdate');
        dispatch({
          type: POST_ORGANIZER_UPDATE_SUCCESS,
          payload: {
            organizerUpdate,
          },
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: POST_ORGANIZER_UPDATE_ERROR,
          payload: { error },
        });
        return error;
      });
  };
}

export function editOrganizerUpdate(campaignId, updateId, update) {
  return (dispatch) => {
    let resParams = {};
    return fetcher(`/donate/api/campaigns/${campaignId}/updates/${updateId}`, {
      method: 'POST',
      body: JSON.stringify(update),
    })
      .then((res) => {
        resParams = {
          ...resParams,
          status: res.status,
          statusText: res.statusText,
          ok: res.ok,
        };
        return res.json();
      })
      .then((resJson) => {
        if (!resParams.ok) {
          const error = {
            ...resJson?.error,
            ...resParams,
          };
          dispatch({
            type: EDIT_ORGANIZER_UPDATE_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        const organizerUpdate = _get(resJson, 'data.organizerUpdate');
        dispatch({
          type: EDIT_ORGANIZER_UPDATE_SUCCESS,
          payload: {
            organizerUpdate,
          },
        });
        return { ...resJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: EDIT_ORGANIZER_UPDATE_ERROR,
          payload: { error },
        });
        return error;
      });
  };
}

export function deleteOrganizerUpdate(campaignId, updateId) {
  return (dispatch) => {
    let resParams = {};
    return fetcher(`/donate/api/campaigns/${campaignId}/updates/${updateId}`, {
      method: 'DELETE',
    })
      .then((res) => {
        resParams = {
          ...resParams,
          status: res.status,
          statusText: res.statusText,
          ok: res.ok,
        };
        return res.json();
      })
      .then((resJson) => {
        if (!resParams.ok) {
          const error = {
            ...resJson?.error,
            ...resParams,
          };
          dispatch({
            type: DELETE_ORGANIZER_UPDATE_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        dispatch({
          type: DELETE_ORGANIZER_UPDATE_SUCCESS,
          payload: {
            updateId,
          },
        });
        return { ...resJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: DELETE_ORGANIZER_UPDATE_ERROR,
          payload: { error },
        });
        return error;
      });
  };
}

export function incrementOrganizerUpdateCount() {
  return (dispatch) => {
    dispatch({ type: INCREMENT_ORGANIZER_UPDATE_COUNT });
  };
}

export function decrementOrganizerUpdateCount() {
  return (dispatch) => {
    dispatch({ type: DECREMENT_ORGANIZER_UPDATE_COUNT });
  };
}
